import { Product } from "@common/enums/Product.ts";
import {
    clientsDirectColors, compassColors,
    pickleLeadsColors,
    sellersDirectColors,
    themePaletteClientsDir, themePaletteCompass,
    themePalettePickleLeads,
    themePaletteSelDir
} from "@common/utils/productStyles.ts";
import { CategoryEnum } from "@common/enums/CategoryEnum.ts";
import { SubscriptionType } from "@common/enums/SubscriptionTypeEnum.ts";
import { ProductSkeleton } from "@common/types/ProductTypes.ts";
import { capitalizeName } from "@common/utils/textFormat.ts";

const allowedClientUrls = process.env.ALLOWED_CLIENT_URLS?.split(',') as string[] | undefined;
const staticLogo = process.env.STATIC_LOGO as string | undefined;

// This is the main object that holds all the product specific information
export const Products: Record<Product, ProductSkeleton> = {
    [Product.ClientsDirect] : {
        displayName: capitalizeName(Product.ClientsDirect),
        name: Product.ClientsDirect,
        logoFront: { logo: '/images/clientsDirectLogo.png', alt: "Clients Direct Logo", styles: { height: '35px' } },
        logoBack: staticLogo === undefined ? '' : staticLogo.replace('logo_light','clientsDirectLogo'),
        buyerSubType: SubscriptionType.Dynamic,
        uploadDestination: SubscriptionType.Dynamic,
        leadsRequireVerification: true,
        presetCategory: null,
        defaultCategory: CategoryEnum.RealEstate,
        url: allowedClientUrls === undefined ? '' : allowedClientUrls?.find(url => url.includes('clients.direct')) || allowedClientUrls?.find(url => url.includes('clients-direct')) || allowedClientUrls[0],
        emailSender: 'support@clients.direct',
        knownDomains: ['clients.direct', 'clients-direct'],
        icon: '/clients-direct-32.png',
        appColors: clientsDirectColors,
        themePalette: themePaletteClientsDir,
    },
    [Product.SellersDirect] : {
        displayName: capitalizeName(Product.SellersDirect),
        name: Product.SellersDirect,
        logoFront: { logo: '/images/logo_light.png', alt: "SellersDirect Logo", styles: { height: '25px' } },
        logoBack: staticLogo === undefined ? '' : staticLogo,
        buyerSubType: SubscriptionType.Dynamic,
        uploadDestination: SubscriptionType.Dynamic,
        leadsRequireVerification: false,
        presetCategory: CategoryEnum.RealEstate,
        defaultCategory: CategoryEnum.RealEstate,
        url: allowedClientUrls === undefined ? '' : allowedClientUrls?.find(url => url.includes('sellersdirect')) || allowedClientUrls[0],
        emailSender: 'support@sellersdirect.com',
        knownDomains: ['sellersdirect'],
        icon: '/icon-1.png',
        appColors: sellersDirectColors,
        themePalette: themePaletteSelDir,
    },
    [Product.Compass] : {
        displayName: capitalizeName(Product.Compass),
        name: Product.Compass,
        logoFront: { logo: '/images/compassLogo.png', alt: "Compass Logo", styles: { height: '50px' } },
        logoBack: staticLogo === undefined ? '' : staticLogo.replace('logo_light','compassLogo'),
        buyerSubType: SubscriptionType.Static,
        uploadDestination: SubscriptionType.Static,
        leadsRequireVerification: false,
        presetCategory: CategoryEnum.RealEstate,
        defaultCategory: CategoryEnum.RealEstate,
        url: allowedClientUrls === undefined ? '' : allowedClientUrls?.find(url => url.includes('mycompassleads') || url.includes('compass')) || allowedClientUrls[0],
        emailSender: 'support@mycompassleads.com',
        knownDomains: ['compass', 'mycompassleads'],
        icon:  '/compass-icon.ico',
        appColors: compassColors,
        themePalette: themePaletteCompass,
    },
    [Product.PickleLeads] : {
        displayName: capitalizeName(Product.PickleLeads),
        name: Product.PickleLeads,
        logoFront: { logo: '/images/pickleLeadsLogo.png', alt: "Pickle Leads Logo", styles: { height: '42px', marginTop: '5px' } },
        logoBack: staticLogo === undefined ? '' : staticLogo.replace('logo_light','pickleLeadsLogo'),
        buyerSubType: SubscriptionType.Dynamic,
        uploadDestination: SubscriptionType.Dynamic,
        leadsRequireVerification: false,
        presetCategory: CategoryEnum.RealEstate,
        defaultCategory: CategoryEnum.RealEstate,
        url: allowedClientUrls === undefined ? '' : allowedClientUrls?.find(url => url.includes('pickleleads')) || allowedClientUrls[0],
        emailSender: 'support@pickleleads.com',
        knownDomains: ['pickleleads'],
        icon: '/pickle-leads-icon.png',
        appColors: pickleLeadsColors,
        themePalette: themePalettePickleLeads,
    }
}